
  import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
  import { Navigation, Pagination } from 'swiper'
  import 'swiper/swiper-bundle.css'
  import recommendMatched from '~/mixins/recommend-matched'
  SwiperCore.use([Navigation, Pagination])
  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    mixins: [recommendMatched],
    data() {
      return {
        checkInterest: false
      }
    },
    mounted() {
      if (!this.recommendItems || !this.recommendItems?.length) {
        this.$store.dispatch('games/getRecommendedMatchItems', { platform: 1 })
      }
    },
    methods: {
      onIntersect(entries, observer) {
        const interesting = entries[0]?.isIntersecting
        if (interesting) {
          this.checkInterest = true
        }
      }
    }
  }
